<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.WaterTemperatureMangawhai"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.UaHakaruRiver"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.LakeKanonoFlow"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.RainfallHakaruRiver"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.RainfallPaparoaTaylors"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.RainfallKaiparaHarbour"></app-basic-cartesian-chart>
